import { render, staticRenderFns } from "./WishlistAddButton.vue?vue&type=template&id=10ddc852&"
import script from "./WishlistAddButton.vue?vue&type=script&lang=js&"
export * from "./WishlistAddButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports